export const SIGNUP_SUBMIT = "x/SIGNUP_SUBMIT";
export function signupSubmit ( data ) {
    return {
        type: SIGNUP_SUBMIT,
        payload: data
    };
}